import { render, staticRenderFns } from "./Notice.vue?vue&type=template&id=5eaf6003&"
import script from "./Notice.vue?vue&type=script&lang=ts&"
export * from "./Notice.vue?vue&type=script&lang=ts&"
import style0 from "./Notice.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports